<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.97765 3L5.99988 4.11284L9.90445 10.704L11.8822 9.59114L7.97765 3ZM9.90419 12.6851H1.99994V10.704H9.99993V12.6851H9.90524L11.8822 13.7656L7.97765 20.1685L5.99988 19.0875L9.90419 12.6851ZM21.9999 12.6851H13.9999V10.704H21.9999V12.6851ZM18 19.0875L15.9431 20.1685L11.8823 13.7657L13.9392 12.6846L18 19.0875ZM18 4.11284L15.9431 3L11.8823 9.59114L13.9392 10.704L18 4.11284Z"
  />
</template>
